import styled from "styled-components";

export const SocialMediaAccountWidgetStyled = styled.div`
  margin: auto;
  width: 100%;
  padding: 30px 0;
  background: ${({ theme }) => theme.COLORS.BLACK_5};
  .social_media_account_list {
    margin: auto;
    display: flex;
    justify-content: center;
    gap: 15px;
    .social_item {
      background: transparent;
      cursor: pointer;
      &:hover {
        svg {
          path {
            fill: ${({ theme }) => theme.COLORS.GRAY_9};
          }
        }
      }
    }
    .youtube {
      background: transparent;
      cursor: pointer;
      &:hover {
        svg {
          path:not(:nth-child(2)) {
            fill: ${({ theme }) => theme.COLORS.GRAY_9};
          }
        }
      }
    }
  }
`;
